<template>
  <router-view id="page-content-wrapper"></router-view>
</template>

<script>
export default {
name: "Port"
}
</script>

<style scoped>

</style>